const shareButton = document.getElementById('portimao-share-challenge');
const challengeField = document.getElementById('challenge-url');
const copyButton = document.getElementById('copy-challenge');
const resultTime = document.getElementById('result-time');
const shareStatus = document.getElementById('share-status');

window.addEventListener('rmc:result-view', ({ detail }) => {
  shareButton.hidden = detail.demo;
});

shareButton.addEventListener('click', async () => {
  const url = challengeField.value;
  if (copyButton.disabled || !url.includes('#challenge=')) return;

  const message = shareButton.dataset.message.replace('__TIME__', resultTime.textContent.trim());
  if (navigator.share) {
    try {
      await navigator.share({ text: message, url });
      return;
    } catch (error) {
      if (error.name === 'AbortError') return;
    }
  }

  try {
    await navigator.clipboard.writeText(`${message}\n${url}`);
    shareStatus.textContent = shareButton.dataset.copied;
  } catch {
    const details = challengeField.closest('details');
    if (details) details.open = true;
    challengeField.focus();
    challengeField.select();
    shareStatus.textContent = shareButton.dataset.manual;
  }
});
